<template>
  <div>
    <alert
      v-model="notify.show"
      :errorType="notify.type"
      :message="notify.message"
    />
    <container class=" mx-4">
      <div class="quiz">
        <div v-for="(growth, index) in growth_plan" :key="growth.id">
          <div class="question-head mb-4 flex justify-between font-black">
            <h6>Question {{ index + 1 }}</h6>
          </div>
          <div class="mb-4">
            <div>
              {{ growth.question }}
            </div>
            <ltextarea class="resize-none" v-model="growth.answer" disable />
          </div>
        </div>
      </div>
    </container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getUser", "getLearnerLesson"]),
  },
  props: ["growth_plan"],
  methods: {
    ...mapActions(["takeGrowthPlan", "learnerGetGrowthPlan"]),
    async submitGrowthPlan() {
      let res = await this.takeGrowthPlan({
        id: this.$route.params.lesson_id,
        response: this.response,
      });
      if (res == true || res.status == 200 || res.status == 201) {
        this.form = {};
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Growth plan submitted successfully",
        });
        this.$Bus.$emit("submit-resource", {});
      } else {
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
  },
  data() {
    return {
      answers: [],
      showAnswers: false,
      score: 0,
      alert: false,
      response: "",
      notify: {
        type: null,
        show: false,
        message: "",
      },
    };
  },
  async mounted() {},
  components: {
    container: () => import("@/components/general/container"),
    LmsButton: () => import("@/components/general/button"),
    Alert: () => import("@/components/tenant/alert"),
    ltextarea: () => import("@/components/general/textarea"),
  },
};
</script>
<style lang="scss" scoped>
.quiz {
  .navs {
    color: color(lms-tenant);
  }
  .description {
    h6 {
      color: color(lms-tenant);
    }
  }
  .question-head {
    color: color(lms-tenant);
  }
}
</style>
